<svg [flag]="flag()"></svg> <span class="tw:uppercase">{{ abbr() | slice: 0 : 2 }}</span>
